import React, {useMemo, useState} from "react";
import {injectIntl} from "react-intl";
import {useSelector} from "react-redux";
import axios from "axios";
import {headerSortingClasses, sortCaret} from "../../../../_metronic/_helpers";
import {Card, CardBody, CardHeader, CardHeaderToolbar} from "../../../../_metronic/_partials/controls";
import {PaginationTable} from "../../../components/PaginationTable/PaginationTable";
import {SupplierInfoColumnFormatter} from "../ColumnsFormatter/SupplierInfoColumnFormatter";
import EditOrAddSupplier from "./EditOrAddSupplier";
import AdminSnackbar from "../AdminSnackbar";
import {UserActiveColumn} from "../ColumnsFormatter/UserInfoColumn";


function SupplierAdminPage(props) {

    const initialValues = useMemo(() => ({
        entityName: "",
        pointOfContact: "",
        Mas90VendorNumber: "",
        phoneNumber: "",
        postalAddress: "",
        postalCity: "",
        postalZipcode: "",
        physicalAddress: "",
        physicalCity: "",
        physicalZipcode: "",
        email: "",
        description: "",
        logoPath: "",
        active: "",
        isOfficial: ""
    }), []);

    const {user,accessToken} = useSelector (
        ({auth}) =>({
            user: auth.user != null ? auth.user : null,
            accessToken: auth.authToken,
        })
    )

    const initialData = {
        data: [],
        totalCount: 0,
        pageSize: 10
    }

    const [data,setData] = useState(initialData)
    const [edit, setEdit] = useState(false)
    const [openSupplier, setOpenSupplier] = useState(false)
    const [snackbarSupplier, setSnackbarSupplier] = useState(false);
    const [selectedSupplier, setSelectedSupplier] = useState(initialValues)
    const [isLoading, setIsLoading] = useState(false)


    const fetchSuppliers = (queryParams) => {
        // Authorization head should be fulfilled in interceptor.
        console.log("fetching suppliers for table")
        setIsLoading(true)
        
        // Stringify filter object for backend (backend expects JSON string)
        const params = { ...queryParams };
        if (params.filter) {
            params.filter = JSON.stringify(params.filter);
        }
        
        const options = {
            headers: { 'x-auth-token': accessToken},
            validateStatus: status => status < 500,
            params: params
        }
        axios.get(process.env.REACT_APP_API_URL + '/tenants/suppliers', options).then(response =>{
            setData(response.data)
            console.log("Suppliers: ", response.data);
            setIsLoading(false)
        }).catch(error => {
            console.log(error);
            setIsLoading(false)
        });
    }


    const columns = [
        {
            dataField: "entityName",
            text: "Name",
            sort: true,
            sortCare: sortCaret,
            headerSortingClasses,
            formatter: SupplierInfoColumnFormatter,
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    setSelectedSupplier(row)
                    setEdit(true)
                    setOpenSupplier(true)
                }
            },
        },
        {
            dataField: "postalAddress",
            text: "Postal Address",
            sort: true,
            sortCare: sortCaret,
            headerSortingClasses,
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    setSelectedSupplier(row)
                    setEdit(true)
                    setOpenSupplier(true)
                }
            },
        },
        {
            dataField: "postalCity",
            text: "City",
            sort: true,
            sortCare: sortCaret,
            headerSortingClasses,
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    setSelectedSupplier(row)
                    setEdit(true)
                    setOpenSupplier(true)
                }
            },
        },
        {
            dataField: "postalZipcode",
            text: "Zip Code",
            sort: true,
            sortCare: sortCaret,
            headerSortingClasses,
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    setSelectedSupplier(row)
                    setEdit(true)
                    setOpenSupplier(true)
                }
            },
        },
        {
            dataField: "active",
            text: "Is Active",
            sort: true,
            sortCare: sortCaret,
            headerSortingClasses,
            formatter: UserActiveColumn,
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    setSelectedSupplier(row)
                    setEdit(true)
                    setOpenSupplier(true)
                }
            },
        },
    ];

    const sizePerPageList = [
        { text: "5", value: 5 },
        { text: "10", value: 10 },
        { text: "15", value: 15 }
    ]

    const initialFilter = {
        filter: {
            entityName:"",
            postalAddress: "",
            postalCity:"",
            postalZipcode: ""
        },
        sortOrder: "asc",
        sortField: "entityName",
        pageNumber: 1,
        pageSize: 10
    }

    const sorting = [{dataField: "entityName",order:"asc"}]
    const pagination = {custom: true, sizePerPageList: sizePerPageList}
    const tableClasses = "table table-head-custom table-head-bg table-borderless table-vertical-center"

    const prepareFilter = (queryParams,values) => {
        const {searchText} = values;
        const newQueryParams = {...queryParams};
        const filter = {};

        filter.entityName = searchText ?? "";
        filter.postalAddress = searchText ?? "";
        filter.postalCity = searchText ?? "";
        filter.postalZipcode = searchText ?? "";


        newQueryParams.filter = filter;
        return newQueryParams;
    }

    return (
        <>
            {openSupplier ?
                <EditOrAddSupplier supplierInformation={selectedSupplier} edit={edit} setEdit={setEdit}
                                   setShowSnackbar={setSnackbarSupplier} showSnackbar={snackbarSupplier}
                                   openSupplier={openSupplier} setOpenSupplier={setOpenSupplier}
                                   setSelectedSupplier={setSelectedSupplier} initialValues={initialValues}/>
                :
                <Card>
                    <CardHeader title="Suppliers">
                        <CardHeaderToolbar>
                            <button type="button" className="btn btn-primary" onClick={() => {
                                setSelectedSupplier(initialValues);
                                setEdit(false);
                                setOpenSupplier(true);
                            }}>
                                New Supplier
                            </button>
                        </CardHeaderToolbar>
                    </CardHeader>
                    <CardBody>
                        <PaginationTable
                            data={data}
                            columns={columns}
                            pagination={pagination}
                            isLoading={isLoading}
                            sorting={sorting}
                            tableClasses={tableClasses}
                            fetcher={fetchSuppliers}
                            filterFunction={prepareFilter}
                            initialFilter={initialFilter}/>
                    </CardBody>
                    <AdminSnackbar
                        message={'Supplier information saved successfully'}
                        setShowSnackbar={setSnackbarSupplier}
                        showSnackbar={snackbarSupplier}
                        variant={'success'}
                    />
                </Card>
            }
        </>
    );
}

export default injectIntl(SupplierAdminPage);